import { IDictionaryValue } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { ISupervisionType } from 'APIPackage/DictionariesModule/interfaces/ISupervisionType';

import { DictionaryUUIDsEnum } from '../enums/DictionaryUUIDsEnum';
import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';
import { getKindControlSelectedLabel } from '../../../KnmPackage/MainModule/common/getKindControlSelectedLabel';
import { getKindControlLabel } from '../../../KnmPackage/MainModule/common/getKindControlLabel';

export const createDictionarySupervisionTypeSelectOption = makeCreateDictionarySelectOption<ISupervisionType>(
  'guid',
  'title',
);

export const createDictionarySupervisionTypeExtendedSelectOption = (
  dictionaryId: DictionaryUUIDsEnum,
  dictionaryValue: IDictionaryValue<ISupervisionType>,
  isUseTransferringAuthorities: boolean,
) => {
  const option = makeCreateDictionarySelectOption<ISupervisionType>('id', 'title')(dictionaryId, dictionaryValue);

  return {
    ...option,
    label: getKindControlLabel(option, isUseTransferringAuthorities),
    selectedLabel: getKindControlSelectedLabel(option, isUseTransferringAuthorities),
  };
};
